import { css } from 'lit';
export default css `
  sl-dialog {
    /* SL variables */
    --width: 480px;
    --header-spacing: 0;
    --body-spacing: 0;
    --footer-spacing: 0;

    /* Element variables */
    --private-close-icon-size: 24px;
    --private-side-padding: 24px;
  }

  sl-dialog::part(overlay) {
    background-color: rgba(0, 0, 0, 0.8);
  }

  sl-dialog::part(panel) {
    background-color: #ffffff;
    border-radius: var(--amityeko-radius-large);
  }

  sl-dialog:not(.with-label-icon)::part(header) {
    align-items: center;
    padding: 20px var(--private-side-padding);
    border-bottom: 1px solid var(--amityeko-color-gray-9);
  }

  sl-dialog.with-label-icon::part(header) {
    padding: 20px var(--private-side-padding) 0 var(--private-side-padding);
  }

  sl-dialog:not(.with-label-icon)::part(title) {
    padding-left: var(--private-close-icon-size);
    text-align: center;
  }

  sl-dialog::part(close-button__base) {
    align-self: flex-start;
    padding: 0;
    font-size: var(--private-close-icon-size);
    color: var(--amityeko-color-gray-1);
  }

  sl-dialog::part(close-button__base):hover,
  sl-dialog::part(close-button__base):active {
    color: var(--amityeko-color-gray-3);
  }

  sl-dialog::part(body) {
    padding: 20px var(--private-side-padding);
  }

  sl-dialog.with-label-icon::part(body) {
    padding-top: 16px;
  }

  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .dialog-title amityeko-tg-label-one {
    width: 100%;
    text-align: center;
  }

  .dialog-no-back-btn {
    justify-content: center;
  }

  .back-icon {
    position: absolute;
    left: -27px;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    width: 100%;
    padding: 16px var(--private-side-padding);
    text-align: right;
  }

  .buttons--right {
    display: flex;
  }

  .button {
    display: block;
  }

  .buttons--right .button {
    margin-left: 12px;
  }
  .chip-image {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border-radius: 50%;
  }

  /* * * * VARIANTS * * * */

  /* Variant: primary */
  .variant--primary .label-icon {
    --amityeko-icon-color: var(--amityeko-color-info-6);
    --amityeko-icon-badge-bg-color: var(--amityeko-color-info-1);
  }

  /* Variant: danger */
  .variant--danger .label-icon {
    --amityeko-icon-color: var(--amityeko-color-destructive-6);
    --amityeko-icon-badge-bg-color: var(--amityeko-color-destructive-1);
  }

  /* Variant: pure */
  sl-dialog.variant--pure {
    --width: auto;
  }

  sl-dialog.variant--pure::part(panel) {
    background-color: transparent;
  }

  sl-dialog.variant--pure::part(header) {
    display: none;
  }

  sl-dialog.variant--pure::part(body) {
    padding: 0;
  }

  sl-dialog.variant--pure::part(footer) {
    display: none;
  }

  /* * * * END VARIANTS * * * */
  .buttons--left amityeko-tg-caption,
  amityeko-skeleton {
    height: 100%;
    width: 300px;
    text-align: left;
    display: flex;
    align-items: center;
    color: var(--amityeko-color-gray-5);
    white-space: normal;
  }
`;
//# sourceMappingURL=styles.js.map